module.exports = __webpack_public_path__ + "img/about_graph_m.2b8fb6e3.png";